module.exports = __webpack_public_path__ + "asset/FZCHSJW_IuG8u6hH.ttf";